<template>
  <div @mouseover="play" @mouseout="onMouseOut" class="el-clickthrough">
    <vue-lottie :options="defaultOptions" :height="height" :width="width" @animCreated="handleAnimation" @complete="complete"
      @loopComplete="loopComplete" @enterFrame="enterFrame" @segmentStart="segmentStart" />
    <div v-if="showButtons">
      <!-- <div>
<p>Speed: x{{animationSpeed}}</p>
<input type="range" value="1" min="0" max="3" step="0.5"
v-on:change="onSpeedChange" v-model="animationSpeed" />
</div> -->
      <button v-on:click="stop">stop</button>
      <button v-on:click="pause">pause</button>
      <button v-on:click="play">play</button>
      <button @click="loopTongue">loopTongue</button>
    </div>
  </div>
</template>
<script>
  import VueLottie from '@/components/AnimLottie'
  import * as animationData from '@/assets/animations/tongue.json'

  export default {
    props: {
      width: {
        type: Number,
        default: 120
      },
      height: {
        type: Number,
        default: 120
      },
      showButtons: {
        type: Boolean,
        default: false
      }
    },
    components: {
      VueLottie
    },
    data() {
      return {
        anim: {},
        defaultOptions: {
          animationData: animationData,
          autoplay: false
        },
        animationSpeed: 1
      }
    },
    methods: {
      handleAnimation(anim) {
        this.anim = anim
      },
      onMouseOut() {
        this.anim.playSegments([0, 1], true)
        this.anim.goToAndStop(1, true)
      },
      stop() {
        this.anim.stop()
      },
      play() {
        this.anim.playSegments([13, 78], true)
      },
      pause() {
        this.anim.pause()
      },
      // Animation Event Listeners
      enterFrame(e) {
        // console.log('enterFrame', Math.round(this.anim.currentFrame))
        if (Math.round(this.anim.currentFrame) === 78) {
          this.anim.goToAndPlay(13, true)
        }
      },
      complete(e) {
        // console.log('complete', e)
      },
      loopComplete(e) {
        // console.log('loopComplete', e)
      },
      segmentStart(e) {
        // console.log('segmentStart', e)
      },
    }
  }

</script>

<style lang="scss" scoped>
  .el-clickthrough {
    display: block;
    overflow: hidden;

    * {
      pointer-events: none;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/AnimTongue.vue